import useDimensions from 'react-cool-dimensions';
import styled from 'styled-components';
import { DoqWithSpeechBubble as Doq } from './DoqWithSpeechBubble';
import { DoqLayout, DoqWithSpeechBubbleProps } from './types';
import { isDoqLayout } from './utils';

export type ResponsiveDoqWithSpeechBubbleProps = Omit<
  DoqWithSpeechBubbleProps,
  'layout'
>;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const ResponsiveDoqWithSpeechBubble = (
  props: ResponsiveDoqWithSpeechBubbleProps
) => {
  const { observe: setObservedElementRef, currentBreakpoint } = useDimensions({
    breakpoints: {
      [DoqLayout.DIALOG]: 0,
      [DoqLayout.VERTICAL]: 550,
      [DoqLayout.PAGE]: 880,
    },
    updateOnBreakpointChange: true,
  });

  return (
    <Container ref={setObservedElementRef}>
      {isDoqLayout(currentBreakpoint) && (
        <Doq layout={currentBreakpoint as DoqLayout} {...props} />
      )}
    </Container>
  );
};

export { ResponsiveDoqWithSpeechBubble };
